import type { ExecutiveSummary } from '@wtta/scoring'

interface ExecutiveSummarySectionProps {
  summary: ExecutiveSummary
}

const PRIORITY_LABEL: Record<ExecutiveSummary['topActions'][number]['priority'], string> = {
  critical: 'Kritiek',
  high: 'Hoge prioriteit',
  medium: 'Medium prioriteit',
  low: 'Lage prioriteit',
}

export function ExecutiveSummarySection({ summary }: ExecutiveSummarySectionProps) {
  return (
    <section
      className="report-section executive-summary"
      data-testid="executive-summary"
    >
      <h2 className="report-section__title">Samenvatting</h2>
      <p className="executive-summary__verdict">{summary.verdict}</p>
      <p className="executive-summary__context">{summary.context}</p>

      {summary.topActions.length > 0 ? (
        <div className="executive-summary__top-actions">
          <h3 className="executive-summary__subtitle">Jouw drie belangrijkste acties</h3>
          <ol className="executive-summary__action-list">
            {summary.topActions.map((action) => (
              <li
                key={action.title}
                className={`executive-summary__action priority-${action.priority}`}
                data-testid={`top-action-${action.priority}`}
              >
                <span className="executive-summary__action-priority">
                  {PRIORITY_LABEL[action.priority]}
                </span>
                <strong className="executive-summary__action-title">
                  {action.title}
                </strong>
                <span className="executive-summary__action-rationale">
                  {action.rationale}
                </span>
              </li>
            ))}
          </ol>
        </div>
      ) : null}

      <dl className="executive-summary__stats">
        <div>
          <dt>Tot ingangsdatum</dt>
          <dd data-testid="months-until-start">
            {summary.monthsUntilWttaStart === 0
              ? 'al van kracht'
              : `${summary.monthsUntilWttaStart} ${summary.monthsUntilWttaStart === 1 ? 'maand' : 'maanden'}`}
          </dd>
        </div>
        <div>
          <dt>Aanmeldingsdeadline</dt>
          <dd data-testid="days-until-deadline">
            {summary.daysUntilTransitionDeadline === 0
              ? 'verstreken'
              : `${summary.daysUntilTransitionDeadline} dagen`}
          </dd>
        </div>
      </dl>
    </section>
  )
}
